module.exports = __webpack_public_path__ + "static/media/chlodzenie.e9b9ef63.svg";